const ja = {
	withdrawal: '出金',
	cashAccount: '出金口座',
	change: '変更',
	descriptionOfWithdrawals: '人民元の出金操作手順',
	addbankAccount: '銀行口座追加',
	applyforVirtualAccount: 'バーチャル口座申請',
	virtualName: 'バーチャルアカウント名',
	defaultNameTip: 'アカウント名はピンポン収集プラットフォームに同期され、対応する関係が形成されます。入力しない場合は、システムのデフォルト名が使用されます。',
	virtualCurrency: 'バーチャルアカウント通貨',
	currencyTip: 'この仮想アカウントでサポートされている通貨を選択してください。複数の通貨を選択できます。',
	addCurrency: '通貨を追加',
	delete: '出金口座を削除する',
	deleteAccountTip: '現在の口座に送金されているお金が入金されます。このアカウントを削除すると、お金は元のアカウントに入金されます。',
	deleteSureTip: 'この引き出し口座を削除してもよろしいですか?',
	association: '会社の定款を補足する必要があります。補足しないと、ヨーロッパ通貨を正常に申請できなくなります。アプリケーションを続行しますか?',
	return: '戻る',
	buttonDelete: '削除',
	goInput: '埋める',
	inReview: '審査中',
	reviewFailed: 'レビューに失敗しました',
	reviewPending: '審査中',
	modifyBank: '銀行口座を変更する',
	accountInfo: 'アカウント情報',
	comfirm: '確認する',
	currency: '口座通貨',
	bankName: '銀行名',
	cardNo: '口座番号',
	swiftCode: 'SWIFTコード',
	bankCode: '銀行コード',
	bankCountry: '銀行所在国 / 地域',
	reservedPhoneNo: '電話番号',
	virtualAccountName: '振込先口座',
	virtualSuccess: 'バーチャルアカウントが正常に作成されました!',
	exceed: '仮想アカウントの数は Web サイトの数を超えることはできません',
	withdrawSuccessful: '無事に出金完了',
	inputTip: '出金額を入力してください',
	settlementAmount: '出金額',
	Minimum: '最低出金額100元',
	settlementNum: '出金可能残高',
	all: '全て',
	estimatedTransferredAmount: '受取予定金額',
	withdrawalFee: '出金手数料',
	replacement: '出金口座の変更',
	application: '出金申請が成功しました〜',
	confirmChange: '交換の確認',
	cancel: 'もう一度考えてみます',
	confirm: '確認',
	cancel2: 'キャンセル',
	formRules: '金額が引き出し可能な金額を超えています。確認してもう一度開始してください。',
	//  统一提现
	homeIndex: 'トップページ',
	home: 'ホーム',
	accountBalance: '口座残高',
	withdraw: '出金',
	withdrawTo: 'に撤退する',
	exchange: '変化',
	group: 'グループ',
	availableAmount: '出金可能額',
	withdrawAmount: '出金額',
	totalAmount: '合計金額',
	fees: '出金手数料',
	netAmount: '受取予定金額',
	currents: '送金口座',
	note: 'ヒント',
	currentsTip: 'リチャージ金額は Currentz 製品に転送され、サプライヤーへの支払いなど現金引き出し以外の目的に使用されます。お金を引き出したいだけの場合は、Currentz での追加手数料を避けるために、PingPong Checkout で行うことができます。',
	remark: '追伸',
	remarkNoChineseChars: '附言に中国語の文字は入力できません',
	onlySupportUS: '申し訳ございませんが、バーチャルアカウントとディストリビューションアカウントへの出金は現在サポートされていません。出金操作には米国の銀行口座に切り替えてください。ご理解とご協力をお願いいたします。',
	vaClientIdMismatchDesc: 'VA口座情報が更新されました。現在連携されているPingPongアカウントがVA口座と一致していないため、現時点では出金を完了できません。現在連携されているPingPongアカウントに紐づくVA口座をご利用のうえ、出金手続きを行ってください。ご不明な点がございましたら、カスタマーサポートまでお問い合わせください。',
	clientIdCheckFailed: '出金前のアカウント照合に失敗しました。しばらくしてから再度お試しください。',
	cityRequiredTitle: '事業主体住所の市区町村情報を追加してください',
	cityRequiredDescription: '出金を正常に処理するため、事業主体住所の市区町村情報を入力してください。この情報は国際銀行送金（SWIFT）に必要です。不足している場合、出金失敗や処理遅延の原因となる可能性があります。',
	cityRequiredSubmit: '保存して出金を続ける',
	cityRequiredCancel: '後で行う',
	cityRequiredLabel: '事業主体住所の市区町村',
	cityRequiredPlaceholder: '市区町村名を入力してください',
	cityRequiredTip: '事業主体の登記住所または営業住所に含まれる市区町村情報を入力してください。',
	cityRequiredError: '事業主体住所の市区町村情報を入力してください',
	businessAddressRequiredTitle: '事業主体住所の都道府県、市区町村、町名・番地情報を追加してください',
	businessAddressRequiredDescription: '出金を正常に処理するため、事業主体住所の都道府県、市区町村、町名・番地情報を入力してください。この情報は国際銀行送金（SWIFT）に必要です。不足している場合、出金失敗や処理遅延の原因となる可能性があります。',
	businessAddressStateLabel: '事業主体住所の都道府県',
	businessAddressStatePlaceholder: '都道府県を入力してください',
	businessAddressStateTip: '事業主体の登記住所または営業住所に含まれる都道府県情報を入力してください。',
	businessAddressStateError: '事業主体住所の都道府県情報を入力してください',
	businessAddressCityLabel: '事業主体住所の市区町村',
	businessAddressCityPlaceholder: '市区町村名を入力してください',
	businessAddressCityTip: '事業主体の登記住所または営業住所に含まれる市区町村情報を入力してください。',
	businessAddressCityError: '事業主体住所の市区町村情報を入力してください',
	businessAddressStreetLabel: '事業主体住所の町名・番地',
	businessAddressStreetPlaceholder: '町名・番地を入力してください',
	businessAddressStreetTip: '事業主体の登記住所または営業住所に含まれる町名・番地情報を入力してください。',
	businessAddressStreetError: '事業主体住所の町名・番地情報を入力してください'
}
export default ja
